export const pricingTiers = [
  { max: 599, standard: 175, deep: 265, move: 299, construction: 350 },
  { max: 899, standard: 205, deep: 295, move: 350, construction: 395 },
  { max: 1199, standard: 235, deep: 345, move: 395, construction: 475 },
  { max: 1499, standard: 250, deep: 390, move: 435, construction: 535 },
  { max: 1799, standard: 275, deep: 425, move: 475, construction: 595 },
  { max: 2099, standard: 295, deep: 465, move: 510, construction: 655 },
  { max: 2399, standard: 315, deep: 490, move: 550, construction: 695 },
  { max: 2699, standard: 335, deep: 545, move: 590, construction: 770 },
  { max: 2999, standard: 355, deep: 590, move: 645, construction: 850 },
  { max: 3299, standard: 390, deep: 645, move: 690, construction: 900 },
  { max: 3599, standard: 425, deep: 690, move: 750, construction: 990 },
  { max: 3899, standard: 455, deep: 750, move: 805, construction: 1050 },
  { max: 4199, standard: 475, deep: 815, move: 875, construction: 1150 },
  { max: 4499, standard: 500, deep: 875, move: 950, construction: 1250 },
  { max: 4799, standard: 590, deep: 990, move: 1100, construction: 1350 },
  { max: 5000, standard: 695, deep: 1350, move: 1500, construction: 1750 },
  { max: 5500, standard: 850, deep: 1500, move: 1750, construction: 2000 },
  { max: Infinity, standard: 0, deep: 0, move: 0, construction: 0 },
];

export const getPricesBySqft = (sqft: number) => {
  if (sqft <= 0) {
    return { standard: 0, deep: 0, move: 0, construction: 0 };
  }
  const tier = pricingTiers.find(t => sqft <= t.max) || pricingTiers[pricingTiers.length - 1];
  return {
    standard: tier.standard,
    deep: tier.deep,
    move: tier.move,
    construction: tier.construction
  };
};
